module.exports = __webpack_public_path__ + "512189da7bdae91c50efb1a8fba7c393.png";


//////////////////
// WEBPACK FOOTER
// ./components/profile-header/src/img/practice-cover.png
// module id = 2189
// module chunks = 0